import axios from "axios";

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

const getMaxicareCardInfo = async (clientId) => {
  return (await axios.get(`${API_URL}/api/1/personal_infos/${clientId}/cards/maxicare`))?.data?.maxicare;
};


export { getMaxicareCardInfo };
